export default __webpack_public_path__ + "static/media/4.377c26b5.svg";